import { dispatch } from 'nike-re-framejs';
import axios from 'axios';
import { getUrl } from '@/common/oldMobile';
import { List, fromJS } from 'immutable';

const LIMIT = 10;
const ROWS_COUNT = 10;

export const initTransactionHistory = db =>
    db
        .setIn(['transaction', 'reports', 'transactionHistory'], List())
        .setIn(['transaction', 'reports', 'offset'], 0)
        .setIn(['transaction', 'reports', 'hasMore'], true);

export const loadMoreTransactionHistory = db => {
    const offset = db.getIn(['transaction', 'reports', 'offset']);
    axios.get(getUrl('REPORTS'), { params: { offset, limit: LIMIT } }).then(data =>
        dispatch([
            'commit-update',
            db =>
                db
                    .updateIn(['transaction', 'reports', 'transactionHistory'], old =>
                        old.concat(fromJS(data.transactionHistory))
                    )
                    .setIn(['transaction', 'reports', 'hasMore'], data.transactionHistory.length === LIMIT)
                    .setIn(['transaction', 'reports', 'offset'], offset + ROWS_COUNT)
                    .setIn(['transaction', 'reports', 'currency'], data.currency)
        ])
    );
    return db;
};
